import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function LinkedinIcon({ link, style, className }) {
  if (logComponent('LinkedinIcon')) { console.debug('LinkedinIcon rendered'); }

  return  (
    <a href={link} className={className} title="Linked In" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon style={style} icon={['fab','linkedin']} />
    </a>
  )
}